(function ($, Global) {
    var ProgressReading = function (selector, contentSelector) {
        this.$el = $(selector);
        this.$content = $(contentSelector);
    }

    ProgressReading.prototype.initEvents = function () {
        this.publishers();
    }

    ProgressReading.prototype.publishers = function () {
        var self = this;

        $(document).on('scroll', function () {
            var docElem = document.documentElement,
                docBody = document.body,
                scrollTop = docElem['scrollTop'] || docBody['scrollTop'],
                scrollBottom = self.$content.prop('scrollHeight') - self.$content.position().top - window.innerHeight / 2,
                scrollPercent = scrollTop / scrollBottom * 100 + '%';

            self.$el.find('.progress-bar').css('width', scrollPercent);
        });
    }

    Global.ProgressReading = ProgressReading;
}(jQuery, window));